import { Card, Col, Collapse, Divider, Row } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TextRegular12, TextRegular14 } from 'styles/typography';

interface IProps {
  categoryName?: string;
  startDate?: string;
  endDate?: string;
  notes?: string;
}

const TaskBasicInfoCard: FC<IProps> = ({
  categoryName,
  startDate,
  endDate,
  notes,
}) => {
  const { t } = useTranslation();

  return (
    <Card bordered={false} style={{ marginTop: 12 }}>
      <Row>
        <Col span={12}>
          <TextRegular14>
            {t('Task.ProgressUpdate.Category', 'Category')}
          </TextRegular14>
        </Col>

        <Col span={12}>
          <TextRegular12>{categoryName}</TextRegular12>
        </Col>
      </Row>
      <Divider dashed />

      <Row>
        <Col span={12}>
          <TextRegular14>
            {t('Task.ProgressUpdate.PlannedStart', 'Planned start')}
          </TextRegular14>
        </Col>

        <Col span={12}>
          <TextRegular12>{startDate}</TextRegular12>
        </Col>
      </Row>
      <Divider dashed />

      <Row>
        <Col span={12}>
          <TextRegular14>
            {t('Task.ProgressUpdate.PlannedEnd', 'Planned end')}
          </TextRegular14>
        </Col>

        <Col span={12}>
          <TextRegular12>{endDate}</TextRegular12>
        </Col>
      </Row>
      <Divider dashed />
      <Collapse ghost>
        <Collapse.Panel
          header={
            <TextRegular14>{t('Task.Details.Notes', 'Notes')}</TextRegular14>
          }
          key="1"
        >
          {notes ? (
            <TextRegular12 style={{ whiteSpace: 'pre-line' }}>
              {notes}
            </TextRegular12>
          ) : (
            <TextRegular12
              style={{
                display: 'block',
                textAlign: 'center',
                color: 'rgba(0, 0, 0, 0.25)',
              }}
            >
              {t('Task.Details.NoNotes', 'No notes')}
            </TextRegular12>
          )}
        </Collapse.Panel>
      </Collapse>
    </Card>
  );
};

export default TaskBasicInfoCard;
